<template>
  <div class="loader-container">
    <div ref="loader" class="loader-icon">
      <img class="lazyload" :src="imageURL" width="100" height="100" alt="Loading...">
    </div>
    <div v-if="showText" class="loader-text">
      {{ loadingText }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'MonogramLoader',
  props: {
    imageURL: { type: String, default: require('../assets/img/src/logos/monogram.svg') },
    text: { type: Array, default: () => [] },
    showText: { type: Boolean, default: false },
    loaded: { type: Boolean, default: false },
    animated: { type: Boolean, default: true },
    scale: { type: Number, default: 1 },
  },
  data() {
    return {

    };
  },
  computed: {
    loadingText() {
      const r = this.getRandomNumber(1, this.text.length) - 1;
      return this.text[r];
    },
  },
  watch: {
    loaded: {
      handler(n, o) {
        this.$refs.loader ? TweenMax.to(this.$refs.loader, 1, {
          alpha: 0, delay: 1, yoyo: false, repeat: 0,
        }) : null;
      },
      immediate: true,
      deep: false,
    },
  },
  mounted() {
    TweenMax.set(this.$refs.loader, { scale: this.scale });
    if (this.animated) { this.animate(); }
  },
  destroyed() {
    TweenMax.killTweensOf(this.$refs.loader);
  },
  methods: {
    animate() {
      TweenMax.to(this.$refs.loader, 0.5, {
        alpha: 0, delay: 0.3, yoyo: true, repeat: -1,
      });
    },
    getRandomNumber(min, max) {
      return (Math.random() * (max - min) + min).toFixed(0);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/settings/config.scss";

.loader-container {
  display: flex;
  flex-direction: column;
  justify-content:center;
  align-items: center;
}

.loader-text {
  font-family: $font-family-grotesk;
  color: $darkBlack;
  font-weight: 400;
  font-size: 22px;
  text-align: center;
  @media screen and (max-width: 480px) {
    font-size: 16px;
  }
}

</style>
